import axios from 'axios'
import { ElMessageBox } from 'element-plus'
// 从环境变量获取后端基础地址，提供默认值作为回退
const baseUrl = process.env.VUE_APP_BACKEND_URL

// 创建axios实例
const service = axios.create({
  baseURL: baseUrl, // 前台后端API服务地址
  timeout: 60000, // 增加到60秒，适应大文件上传
  // 上传文件时禁用超时，由浏览器控制上传时间
  timeoutMessage: '请求超时，请检查网络连接或文件大小'
})

// 请求拦截器
  service.interceptors.request.use(
    config => {
      // 如果存在token，则添加到请求头中
      const token = localStorage.getItem('token') || ''
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    },
    error => {
      console.error('请求错误:', error)
      return Promise.reject(error)
    }
  )

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 统一处理响应数据格式
    if (res.code === 200) {
      return res
    } else {
      // 显示错误消息
      if(res.code === 10005 || res.code === 10003 || res.code === 10030 || res.code === 10020){
        res.message = '登录过期，请重新登录'
        
        // 只对认证相关的接口进行token清除和退出登录处理
        // 避免普通接口错误也导致用户被强制退出
        const url = response.config.url || ''
        const isAuthRelated = url.includes('/login') || 
                             url.includes('/logout') || 
                             url.includes('/user/info') ||
                             url.includes('/user/bind-phone') ||
                             url.includes('/wechat/')
        
        if (isAuthRelated) {
          localStorage.removeItem('token') // 清除token
          localStorage.removeItem('token_expires') // 清除过期时间
          // 动态导入userStore并清除token和用户信息
          import('@/store/modules/user').then(({ useUserStore }) => {
            const userStore = useUserStore()
            userStore.clearToken()
            userStore.clearUserInfo()
          })
          // 动态导入router
          import('@/router').then(({ default: router }) => {
            router.push('/login')
          })
        }
      }
      /* ElMessageBox.alert((res.message || '请求失败'), '错误', {
        confirmButtonText: '确定',
        type: 'error',
        dangerouslyUseHTMLString: true
      }).catch(() => {
        // 用户点击关闭按钮，忽略错误
      }) */
      // 对于业务错误，不使用Promise.reject，而是使用resolve返回错误信息
      // 这样可以避免浏览器在开发者工具中暂停在Promise rejection处
      return Promise.resolve({
        code: res.code,
        message: res.message || '请求失败',
        data: null,
        error: true
      })
    }
  },
  error => {
    console.error('响应错误:', error)
    
    // 处理token过期或未授权的情况
    if (error.response && error.response.status === 401) {
      ElMessageBox.alert('登录已过期，请重新登录', '错误', {
        confirmButtonText: '确定',
        type: 'error',
        dangerouslyUseHTMLString: true
      }).catch(() => {
        // 用户点击关闭按钮，忽略错误
      })
      localStorage.removeItem('token')
      
      // 动态导入router
      import('@/router').then(({ default: router }) => {
        router.push('/login')
      })
    } else if (error.response && error.response.status === 429) {
      // 处理请求过于频繁的情况，显示后端返回的具体消息
      const errorMessage = error.response.data?.message || '请求过于频繁，请稍后再试'
      ElMessageBox.alert(errorMessage, '错误', {
        confirmButtonText: '确定',
        type: 'error',
        dangerouslyUseHTMLString: true
      }).catch(() => {
        // 用户点击关闭按钮，忽略错误
      })
    } else {
      /* // 对于其他错误，显示后端返回的具体消息或通用错误消息
      const errorMessage = error.response?.data?.message || error.message || '网络错误'
      ElMessageBox.alert(errorMessage, '错误', {
        confirmButtonText: '确定',
        type: 'error',
        dangerouslyUseHTMLString: true
      }).catch(() => {
        // 用户点击关闭按钮，忽略错误
      }) */
    }
    
    return Promise.reject(error)
  }
)

export default service